import React from 'react'
import IndividualCategory from '../DTC/grassdoor/IndividualCategory';

const SimilarProducts = ({ similarProducts }) => {

  return (
    <div className='search-product'>
      <IndividualCategory data={{ products: similarProducts }} isSearchPage isSimlarProduct />
    </div>
  )
}

export default SimilarProducts